import * as type from './constant';

export const getJobDescription = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getJobDescriptionSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getJobDescriptionError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addJobDescription = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addJobDescriptionSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateJobDescription = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateJobDescriptionSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteJobDescription = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteJobDescriptionSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationJobDescriptionError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
